// extracted by mini-css-extract-plugin
module.exports =  {"banner-text-bold":"_32bbee5fda--banner-text-bold--u9Hpv"};